import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { tokenValid } from '../../helpers';
const AuthRoute = props => {
  const {
    token,
    redirect,
    from
  } = props;
  const pathname = redirect || '/login';
  const state = {
    from
  };
  return tokenValid(token) ? /*#__PURE__*/React.createElement(Outlet, null) : /*#__PURE__*/React.createElement(Navigate, {
    to: pathname,
    state: state
  });
};
export { AuthRoute };